var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dashboard-page bold tablec" }, [
    _c(
      "div",
      { staticClass: "d-flex flex-row" },
      [
        _c(
          "Widget",
          {
            staticClass: "w-100",
            attrs: {
              title: "Notifications",
              fetchingData: _vm.isReceiving || _vm.isDeleting
            }
          },
          [
            _vm.hasAdminRole()
              ? _c(
                  "b-button",
                  {
                    staticClass: "mb-3 mt-3",
                    attrs: { variant: "success" },
                    on: {
                      click: function($event) {
                        return _vm.$router.push(
                          "/app/content/notifications/create"
                        )
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                Create new notification\n            "
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "table-resposive" }, [
              _c("table", { staticClass: "table" }, [
                _c("thead", [
                  _c("tr", [
                    _c("th", [_vm._v("Message")]),
                    _vm._v(" "),
                    _c("th", { staticClass: "hidden-sm-down" }, [
                      _vm._v("Visibility")
                    ]),
                    _vm._v(" "),
                    _c("th", { staticClass: "hidden-sm-down" }, [
                      _vm._v("Send to all")
                    ]),
                    _vm._v(" "),
                    _c("th", { staticClass: "hidden-sm-down" }, [
                      _vm._v("Recurrence UM")
                    ]),
                    _vm._v(" "),
                    _c("th", { staticClass: "hidden-sm-down" }, [
                      _vm._v("Start date")
                    ]),
                    _vm._v(" "),
                    _c("th", { staticClass: "hidden-sm-down" }, [
                      _vm._v("End date")
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.notifications, function(row) {
                    return _c("tr", { key: row.id }, [
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            row.message.length > 20
                              ? row.message.substring(0, 20) + "..."
                              : row.message
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(row.public))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(row.sendToAll))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(row.recurrenceUM))]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            row.recurrenceUM == "Once"
                              ? _vm.formatStringDatetime(row.startTime)
                              : _vm.formatDate(row.startDate, row.timezone)
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            row.recurrenceUM == "Once"
                              ? ""
                              : _vm.formatDate(row.endDate, row.timezone)
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _vm.hasAdminRole(row.global)
                            ? _c(
                                "b-button-toolbar",
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: { variant: "info", size: "xs" },
                                      on: {
                                        click: function($event) {
                                          return _vm.$router.push(
                                            "/app/content/notifications/" +
                                              row.id
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "d-none d-md-inline-block"
                                        },
                                        [_vm._v("Edit")]
                                      ),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "d-md-none" }, [
                                        _c("i", { staticClass: "la la-edit" })
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        id: "popoverDelete_" + row.id,
                                        variant: "danger",
                                        size: "xs"
                                      }
                                    },
                                    [
                                      _vm.isDeleting
                                        ? _c("Loader", { attrs: { size: 14 } })
                                        : _c("span", [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "d-none d-md-inline-block"
                                              },
                                              [_vm._v("Delete")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "d-md-none" },
                                              [
                                                _c("i", {
                                                  staticClass: "la la-remove"
                                                })
                                              ]
                                            )
                                          ])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-popover",
                                    {
                                      staticClass: "popover-danger",
                                      attrs: {
                                        triggers: "focus",
                                        target: "popoverDelete_" + row.id,
                                        show: _vm.popovers[row.id],
                                        placement: "top"
                                      },
                                      on: {
                                        "update:show": function($event) {
                                          return _vm.$set(
                                            _vm.popovers,
                                            row.id,
                                            $event
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("template", { slot: "title" }, [
                                        _c("div", { staticClass: "px-5" }, [
                                          _vm._v("Are you sure")
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "px-5 d-flex justify-content-center"
                                        },
                                        [
                                          _c(
                                            "b-button-toolbar",
                                            [
                                              _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    variant: "success",
                                                    size: "xs"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.deleteNotificationRequest(
                                                        {
                                                          id: row.id,
                                                          $toasted: _vm.$toasted
                                                        }
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                Yes\n                                            "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    variant: "danger",
                                                    size: "xs"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.closePopover(
                                                        row.id
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                No\n                                            "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  }),
                  0
                )
              ])
            ])
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }